
namespace RecordShield.Workspace {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class TopSeenLectureDialog extends Serenity.EntityDialog<TopSeenLectureRow, any> {
        protected getFormKey() { return TopSeenLectureForm.formKey; }
        protected getLocalTextPrefix() { return TopSeenLectureRow.localTextPrefix; }
        protected getNameProperty() { return TopSeenLectureRow.nameProperty; }
        protected getService() { return TopSeenLectureService.baseUrl; }
        private topSeenLectureGrid: TopSeenLectureGrid;

        protected form = new TopSeenLectureForm(this.idPrefix);

       // public productAnalyticsForm: ProductAnalyticsForm;
        public ProductId: string;

        constructor() {           
            super();
           
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            debugger;
            this.topSeenLectureGrid = new TopSeenLectureGrid(this.byId("TopSeenLectureGrid"), this.ProductId);
        }
        protected getToolbarButtons() {
            //var buttons = super.getToolbarButtons();
            let buttons = [];
           
            return buttons;
        }
    }
}